import { COVERT_PT_BR } from "#pages/place/settings/couvert/translations";
import { vendor } from "./vendor";

export const settings = {
	title: "Editar configurações",
	error: "Sem permissão para editar local",
	alterImage: "Imagem alterada com sucesso",
	attention: "Atenção!",
	url: "nomedoproduto",
	daysAndWorkingPeriod: "Dias e horário de funcionamento",
	address: {
		postalCode: "CEP",
		state: "Estado",
		city: "Cidade",
		neighborhood: "Bairro",
		address: "Endereço",
		number: "Número",
		complement: "Complemento",
	},
	workingPeriod: {
		deletedPeriod: "Período deletado.",
		addDaysAndTime: "Adicionar dias e horários",
		addOpeningHours: "Adicionar horário de funcionamento",
		daysOfTheWeek: "Dias da semana",
		start: "Início",
		end: "Final",
	},
	menu: {
		title: "Outras opções de configuração",
		general: {
			title: "Gerais",
			subtitle: "Informe limite, e-mails e outros",
		},
		productsWeb: {
			title: "Produtos Web",
			subtitle:
				"Configure a vinculação de bar para delivery.",
		},
		record: {
			title: "Configuração de Fichas",
			subtitle: "Configure o modo ficha",
		},
		couvert: {
			title: "Couvert",
			subtitle: "Configure os valores de couverts",
		},
		features: {
			title: "Funcionalidades",
			subtitle: "Ative e desative funcionalidades",
		},
		pdv: {
			title: "PDV",
			subtitle: "Configure o ponto de venda",
		},
		vendor: {
			title: "Vendor",
			subtitle: "Configure taxas dos vendors",
		},
		totem: {
			title: "Totem",
			subtitle: "Personalize os totens de atendimento",
		},
		refundReason: {
			title: "Motivos de Estorno/Cancelamento",
			subtitle: "Configure os motivos para o PDV",
		},
		fiscalPrinter: {
			title: "Impressoras fiscais",
			subtitle: "Configure as impressoras fiscais do local",
		},
	},
	productsWeb: {
		title: "Produtos Web",
		subtitle: "Configure o link e demais informações do Entregue Já e Pedido na Mesa.",
		saveChanges: "Salvar alterações",
		toastSuccess: "Configurações salvas com sucesso",
		toastError: "Não foi possível salvar as alterações. Por favor, tente novamente.",
		generalTab: {
			urlLabel: "Endereço URL",
			urlSubtitle:
				"Defina o endereço url de acesso para o Cardápio digital, Entregue Já, Pedido na Mesa e Comanda Online.",
			slugInvalid: "O slug deve conter apenas letras, números, hífens e underscores",
			barLabel: "Vinculação de bar",
			barSubtitle:
				"Defina para qual bar os cardápios criados a partir da integração por delivery serão vinculados.",
			selectBarLabel: "Selecione um bar",
			selectBarTooltip:
				"Só é possível vincular apenas um bar para os cardápios criados a partir de integrações",
			save: "Salvar Alterações",
		},
	},
	warningDialog:
		"Você está habilitando pagamentos pós-pagos em '{{name}}'. " +
		"Você está certo disso? Para confirmar a modificação, " +
		"favor digitar '{{text}}'",
	data: {
		label: "Dados",
		name: "Nome",
		selectProduct: "Selecione um produto para habilitar depósito caução automático",
		noneProduct: "Nenhum produto",
		peopleCapacity: "Capacidade",
		slug: "Slug",
		peopleCapacityTooltip: "Quantidade de pessoas que o local comporta.",
	},
	passTemplate: "ID do modelo do passe",
	limits: {
		label: "Limites e serviços",
		postPaidLimit: "Limite de pós-pago",
		serviceTax: "Taxa de serviço",
		rechargeNotIntegratedLimit: "Limite de recarga não integrada",
		nonIntegratedPaymentLimit: "Limite de pagamento não integrado por device e evento",
		enableBuiltInLimit: "Ativar limite de recarga não integrada",
		enableNonIntegratedPaymentLimit:
			"Ativar limite de pagamento não integrado por device e evento",
		nonIntegratedPaymentLimitTooltip:
			"Este limite se refere ao valor máximo de pagamentos não integrados " +
			"que um dispositivo pode receber durante o evento. Esse parâmetro é a soma " +
			"do total de Recargas e Vendas Sem Cartão feitos com pagamentos não integrados.",
		nonIntegratedRechargeLimitTooltip:
			"Este limite se refere ao valor máximo que um funcionário pode fazer em uma recarga não integrada.",
	},
	settings: {
		label: "Configurações",
		myActionsPassword: {
			label: "Senha do ¨Minhas ações¨",
			placeholder: "Insira uma senha numérica ou a senha padrão será 9090",
		},
		sellVisualizationFormat: {
			label: "Formato de visualização dos produtos na venda",
			grid: "Grade",
			list: "Lista",
		},
		kdsServer: {
			label: "IP do servidor KDS",
			placeholder: "Digite o IP",
		},
	},
	everest: {
		label: "Everest",
		user: "Usuário",
		password: "Senha",
		cnpj: "CNPJ",
		host: "Host",
	},
	placeFeatures: "Funcionalidades",
	email: "E-mails para recebimento do fechamento dos eventos",
	emailError: "Email inválido",
	consumption: {
		label: "Configuração fiscal de consumação mínima",
		fiscalProfile: "Perfil fiscal",
		fiscalGroup: "Grupo fiscal",
		ncm: "NCM",
	},
	alert: "Modificações foram realizadas, salve para mantê-las",
	save: "Salvar",
	saveSettings: "Salvar configurações",
	image: "Foto",
	ficha: {
		label: "Ficha",
		text: "Título da Ficha",
		placeholderText: "Insira o título da ficha",
		logo: "Imagem na ficha",
		upload: "Anexar imagem",
		formatError: "Formato não suportado",
		imageFormatMessage: "É necessário que a imagem seja um PNG ou SVG.",
		recommendationMessage:
			"Recomendamos que a imagem atribuída seja o <strong>logo</strong> da empresa na <strong>cor preta</strong>, uma vez que não é possível realizar a impressão de outra cor.",
		dragOrSelectMessage:
			"Arraste a imagem do computador ou selecione a partir de 'Anexar imagem'.",
		logoFormatMessage:
			"É necessário que o <strong>fundo da imagem/logo esteja branco</strong>, para que fique transparente na impressão.",
		dimensionsMessage:
			"As dimensões sugeridas para uma boa resolução são as de <strong>472x472</strong> px.",
		size: {
			Small: "P - Pequeno",
			Medium: "M - Médio",
			Large: "G - Grande",
			NoImage: "Sem Imagem",
			NoQRCode: "Sem QRCode",
			recommend: "recomendado",
		},
		fontSize: "Tamanho da fonte",
		imageSize: "Imagem",
		qrCodeSize: "Tamanho do QR Code",
	},
	couvertEdit: COVERT_PT_BR,
	devices: {
		label: "PDVs do local ({{counter}})",
		placeholder: "Adicionar um PDV a esse local",
		requestDevices: "Solicitar equipamentos",
	},
	errors: {
		invalidName: "Insira um nome válido",
		invalidTip: "Insira um valor de até 25%",
		postPaidLimit: "Insira um valor válido",
		rechargeNotIntegratedLimit: "Valor mínimo de",
		hasConsumptionObligation:
			"Campo obrigatório para configuração de obrigação de consumo",
		minNonIntegratedPaymentLimit: "Valor mínimo de {{value}}",
		tipOptionsValuesRequired: "Os valores das gorjetas são necessários",
		tipOptionLowerValue: 'O "Valor menor" deve ser menor que os valores médio e maior',
		tipOptionHigherValue: 'O "Valor maior" deve ser maior do que o valor médio',
	},
	totem: {
		logoSelectDescription:
			"<strong>Selecione o logo que melhor se aplica na sua imagem</strong> (desconsidere a cor de fundo)",
		addLogo: "Adicionar",
		important: "Importante",
		instructions: "Recomendações",
		image: "A imagem deve ter  as dimensões de <strong>1080 x 1920</strong> px de altura",
		logo:
			"O logo da <strong>Zig</strong> aparecerá sobre a imagem atribuída, centralizado na parte superior",
		recomendations:
			"É recomendado inserir a mensagem <strong>'toque para iniciar'</strong> para orientar o usuário",
		defaultMessage:
			"Caso não adicione uma imagem de tela inicial, " +
			"a tela padrão da Zig será a sua tela inicial " +
			"(vide primeira imagem em “Cores”)",
		totemImgLabel: "Imagem da tela inicial (opcional)",
		totenCustomizationLabel: "Personalização Totem Ficha",
		removeTotemImage: {
			title: "Deseja excluir a tela inicial?",
			content: "Ao excluir, a tela inicial volta a ser a tela padrão da Zig.",
			confirmBtn: "Sim, quero excluir",
			cancelBtn: "Não",
		},
		colors: "Cores",
		saveMessage: "Salvar personalização",
	},
	tip: {
		taxType: "Tipo de taxa",
		tip: "Gorjeta",
		tipSuggestions: "Sugestões de gorjeta",
		serviceTax: "Taxa de serviço",
		none: "Sem taxa",
		lowerValue: "Valor menor",
		medValue: "Valor médio",
		higherValue: "Valor maior",
		tooltip:
			"As recomendações de gorjeta tornam o pagamento de conta mais fácil, " +
			"oferecendo três opções de porcentagens (Menor, Média e Maior) com base " +
			"no valor total da conta, por exemplo: 5%, 10% e 15% limitado a 25%",
	},
	authKeysFeature: {
		phone: "Telefone",
		email: "E-mail",
		keySelectLabel: "Escolha o tipo de chave",
		addKey: "Adicionar Chaves de autenticação",
		contactsInputLabel: "Adicione uma ou mais chaves para autenticação",
		contactsEmailInputPlaceholder: "Digite um email válido (ex: nomedoemail@gmail.com)",
		contactsPhoneInputPlaceholder:
			"Digite um número de telefone (ex: +55 (00) 0 00000000",
		btnAddKey: "Adicionar chaves de autenticação",
		btnCancelAddKey: "Cancelar",
		authKeyAreaTitle: "Autenticação de saque",
		authKeyAreaSubtitle:
			"Cadastre chaves (e-mail ou telefone) que serão usadas para receber o código de	autenticação ao solicitar um saque.",
		selectContactKeyMessage: "Selecione um tipo de chaves",
		selectContactInputMessage: "Preeencha uma chave de contato",
		contactAlreadyExists: "Esse contato já existe!",
		invalidEmail: "E-mail inválido",
		invalidPhone: "Telefone inválido. Deve conter DDI (ex: +5511999999999)",
		incompletePhone: "Número de telefone incompleto. Digite todos os dígitos.",
		invalidDDI:
			"Apenas números brasileiros são aceitos. Use o DDI +55 ou deixe em branco.",
		errorCreatingAuthKeys: "Erro ao criar chaves de autenticação",
		invalidContactsFound:
			"Contatos inválidos encontrados. Verifique os dados e tente novamente.",
		errorCreatingSomeKeys: "Erro ao criar algumas chaves: {{errors}}",
	},
	vendor,
	invoiceMoment: {
		fieldLabel: "Selecione o momento para emissão de Fatura cashless",
		tip:
			"Selecione o momento da emissão da fatura para pagamentos Cashless. Para todas as outras formas de pagamento, que não sejam Cashless, a fatura será sempre emitida no momento do consumo.",
		recharge: "Recarga",
		rechargeAndActivation: "Recarga e ativação",
		consumption: "Consumo",
		consumptionAndActivation: "Consumo e ativação",
	},
	refundReason: {
		addReason: "Criar motivo",
		cancel: "Cancelamento",
		modalDelete: {
			confirmation: "Deseja remover da lista de motivos de estornos e cancelamento?",
			description:
				"Ao remover o motivo não aparecerá mais, mas permanecerá nos relatórios antigos.",
			title: "Remover motivo de estorno/cancelamento",
		},
		modalForm: {
			addReason: "Criar Motivo",
			allowOpenText: "Habilitar justificativa",
			creatingReason: "Criando um motivo",
			editReason: "Salvar alterações",
			editingReason: "Editando um motivo",
			reason: "Motivo",
			reasonPlaceholder: "Digite o motivo de estorno e/ou cancelamento",
		},
		reason: "Motivo",
		removeReason: "Editar motivo",
		refund: "Estorno",
		table: {
			cancel: "Cancelamento",
			editReason: "Editar motivo",
			observation: "Observação",
			reason: "Motivo",
			refund: "Estorno",
			removeReason: "Remover motivo",
			status: "Status",
		},
		title: "Motivos de Estorno/Cancelamento",
	},
	fiscalPrinter: {
		title: "Impressoras fiscais",
		name: "Nome",
		type: "Tipo",
		ip: "Ip",
		actions: "Ações",
		deletedSuccessfully: "Impressora deletada com sucesso",
		addedSuccessfully: "Impressora adicionada com sucesso",
	},
	defaultDateFilter: "Filtro de data padrão",
};
